import { ScreensList, StackMode } from '@shared-core/navigation/screens-list'

export const APP_DEEP_LINK_PREFIX = 'kartoy://'

export const getAppDeepLink = (path: string) => `${APP_DEEP_LINK_PREFIX}${path.replace(/^\/+/, '')}`

// Пути лежат внутри стеков: корневой навигатор знает только AUTHORIZED и LOGOUT.
export const MOBILE_DEEP_LINK_SCREENS = {
  [StackMode.AUTHORIZED]: {
    screens: {
      [ScreensList.HOME_START]: 'home',
      [ScreensList.TOPUP_AMOUNT]: 'topup',
      [ScreensList.PAYMENT_LINK]: 'payment-link',
    },
  },
  [StackMode.LOGOUT]: {
    screens: {
      [ScreensList.ENTRY_PHONE]: 'phone',
    },
  },
}
